import { useQuery } from '@tanstack/react-query';
import type { WindowTypeDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface CatalogueWindowTypesApiResponse {
  success: boolean;
  data: WindowTypeDto[];
}

/**
 * Hook to fetch window types for a specific material.
 * Calls GET /catalogue/window-types?materialId={id}
 */
export function useWindowTypes(materialId?: number) {
  return useQuery({
    queryKey: queryKeys.catalogue.windowTypes(materialId),
    queryFn: async () => {
      const response = await apiClient.get<CatalogueWindowTypesApiResponse>('/catalogue/window-types', {
        params: { materialId },
      });
      return response.data.data;
    },
    enabled: !!materialId,
    staleTime: 5 * 60 * 1000,
  });
}
